import { Component } from '@angular/core';

@Component({
  selector: 'lib-lamp',
  imports: [],
  templateUrl: './lamp.html',
})
export class Lamp {}
